import { render, staticRenderFns } from "./stickers-sum-view.vue?vue&type=template&id=7d154948&scoped=true"
import script from "./stickers-sum-view.vue?vue&type=script&lang=js"
export * from "./stickers-sum-view.vue?vue&type=script&lang=js"
import style0 from "./stickers-sum-view.vue?vue&type=style&index=0&id=7d154948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d154948",
  null
  
)

export default component.exports